import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import Label from "./label";
export var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var name = _ref.name,
      values = _ref.values,
      currentSelection = _ref.currentSelection,
      onSelect = _ref.onSelect,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["name", "values", "currentSelection", "onSelect", "className", "style"]);

  return values.map(function (value) {
    var id = value.replace(/[\W]/g, "");
    return (
      /*#__PURE__*/
      React.createElement(Aligner, {
        key: value,
        className: className,
        style: style
      },
      /*#__PURE__*/
      React.createElement(RadioButton, _extends({
        id: id,
        value: value,
        name: name,
        checked: value === currentSelection,
        onChange: function onChange(e) {
          return onSelect(e.target.value);
        }
      }, rest)),
      /*#__PURE__*/
      React.createElement(Label, {
        htmlFor: id
      }, value))
    );
  });
};
RadioButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentSelection: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}; // Sauce: https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Advanced_styling_for_HTML_forms#Checkboxes_and_radio_buttons

export var RadioButton =
/*#__PURE__*/
styled.input.attrs(function (props) {
  return {
    diameter: props.diameter || 20,
    type: "radio"
  };
}).withConfig({
  displayName: "RadioButton"
})(["position:relative;width:", "px;height:", "px;appearance:none;border:2px solid #757575;border-radius:100%;margin:0;padding:0;background-color:#fff;&::-ms-check{border:2px solid #757575;border-radius:100%;background-color:#fff;}&:active{background-color:#edeeef;}&:checked::before{position:absolute;content:\"\";width:", "px;height:", "px;top:", "px;right:", "px;background-color:#0a146e;border-radius:100%;}"], function (_ref2) {
  var diameter = _ref2.diameter;
  return diameter;
}, function (_ref3) {
  var diameter = _ref3.diameter;
  return diameter;
}, function (_ref4) {
  var diameter = _ref4.diameter;
  return diameter * 0.6;
}, function (_ref5) {
  var diameter = _ref5.diameter;
  return diameter * 0.6;
}, function (_ref6) {
  var diameter = _ref6.diameter;
  return (diameter - 4 - diameter * 0.6) / 2;
}, function (_ref7) {
  var diameter = _ref7.diameter;
  return (diameter - 4 - diameter * 0.6) / 2;
});
var Aligner =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Aligner"
})(["display:flex;align-items:center;& ", "{flex-shrink:0;margin-right:8px;}"], RadioButton);